(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/tabs-backbone/assets/javascripts/tabs-plugin.js') >= 0) return;  svs.modules.push('/components/components/tabs-backbone/assets/javascripts/tabs-plugin.js'); 
var svs = svs || {};


(function(svs) {
  'use strict';

  svs.components = svs.components || {};

  svs.components.tabPlugins = svs.components.tabPlugins || {};

  svs.components.tabPlugins.backbone = function(options) {
    var self = this;
    var currentView = null;
    var previousSlideId = options.startIndex || 0;

    function init() {
      if (options.tabs) {
        for (var i = 0, length = options.tabs.length; i < length; i++) {
          if (options.tabs[i].view instanceof Backbone.View) {
            options.tabs[i].el = options.tabs[i].view.render().el;
          } else if (!options.tabs[i].el) {
            if (options.tabs[i].wrapperClassName) {
              options.tabs[i].el = $('<div class="' + options.tabs[i].wrapperClassName + '" />');
            } else {
              options.tabs[i].el = $('<div/>');
            }
          }
        }
      }

      self.on('init', function(tab) {
        goToSlide(tab.index);
      });

      self.on('change', function(tab) {
        var currentSlideId = tab.index;

        if (currentSlideId !== previousSlideId) {
          self.trigger('onChange', {
            currentView: options.tabs[currentSlideId],
            previousView: options.tabs[previousSlideId]
          });

          goToSlide(currentSlideId);

          previousSlideId = currentSlideId;
        }
      });
    }

    function getTab(tabIndex) {
      return tabIndex < options.tabs.length ? options.tabs[tabIndex] : {};
    }

    function pushView(viewClass, view, params, tabIndex) {
      setTimeout(function() {
        currentView = {
          tabIndex: tabIndex,
          view: viewClass ? new viewClass({ params: params }) : view
        };

        $(options.tabs[tabIndex].el).html(currentView.view.render().el);

        self.resize();
      }, 0);
    }

    function goToSlide(tabIndex) {
      if (currentView) {
        var previousTab = getTab(currentView.tabIndex);
        var oldView = currentView;

        if (Object.prototype.hasOwnProperty.call(previousTab, 'viewClass')) {
          previousTab.el.html($('<div/>'));

          window.requestIdleCallback(function() {
            if (_.isFunction(oldView.view.dispose)) {
              oldView.view.dispose();
            } else if (_.isFunction(oldView.view.destroy)) {
              oldView.view.destroy();
            }
          });
        }
      }

      var tab = getTab(tabIndex);
      if (Object.prototype.hasOwnProperty.call(tab, 'viewClass')) {
        pushView(tab.viewClass, tab.view, tab.params, tabIndex);
        if (Object.prototype.hasOwnProperty.call(options, 'router')) {
          options.router.navigate(options.statsUrl + tab.id, {
            trigger: false,
            replace: true
          });
        }
      } else if (
        svs.utils.ns.isNamespace('React.isValidElement') &&
        typeof React.isValidElement === 'function' &&
        React.isValidElement(tab.view) &&
        svs.utils.ns.isNamespace('ReactDOM.render') &&
        typeof ReactDOM.render === 'function'
      ) {
        ReactDOM.render(tab.view, options.tabs[tabIndex].el[0]);
      }
    }

    init();
  };
})(svs);

 })(window);